import { Customer } from './customer.interface';
import { Invoice } from './invoice.interface';
import { Reservation } from './reservation.interface';

export interface DeliveryNote {
  id: number;
  uuid: string;
  customer_id: number;
  reservation_id: number;
  invoices_id: number;
  customer_id_folder: number;
  filename: string;
  updated_at: string;
  created_at: string;
  invoices?: Invoice;
  customer?: Customer;
  reservation?: Reservation;
}

export interface DeliveryNoteParams {
  invoice_id: number;
  customer_id: number;
  reservation_id: number;
}
